export const LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER =
  "ladeAuswahlwerteGeschaeftspartner";
export const LADE_DOZENTEN = "ladeDozenten";
